import { useState } from "react";
import Footer from "../../../components/footer/Footer";
import { Link } from "react-router-dom";
import { BiSolidHome } from "react-icons/bi";
import AdminNavbar from "../../Components/AdminNavbar/AdminNavbar";

const imgbbApiKey = "372772eac972cb5bc94f6a3995c54b8e";

// ✅ Generic function to upload to ImgBB and return URL
const uploadImageToImgBB = async (file) => {
  const formData = new FormData();
  formData.append("image", file);

  const res = await fetch(`https://api.imgbb.com/1/upload?key=${imgbbApiKey}`, {
    method: "POST",
    body: formData,
  });
  const data = await res.json();
  if (data.success) {
    return data.data.url;
  } else {
    throw new Error("Image upload failed");
  }
};

const CatalogueUpload = () => {
  const [file, setFile] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [catalogueName, setCatalogueName] = useState("");
  const [brand, setBrand] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleImageChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!file) {
      setStatus("Please select a PDF first.");
      return;
    }

    try {
      setStatus("Uploading...");

      // ✅ Step 1: Upload image to ImgBB if selected
      let imageUrl = "";
      if (imageFile) {
        imageUrl = await uploadImageToImgBB(imageFile);
      }

      // ✅ Step 2: Upload PDF & form data to backend
      const formData = new FormData();
      formData.append("file", file);
      formData.append("catalogueName", catalogueName);
      formData.append("brand", brand);
      formData.append("description", description);
      if (imageUrl) {
        formData.append("imageUrl", imageUrl);
      }

      const res = await fetch(
        "https://backend-server-nine-opal.vercel.app/upload-pdf",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await res.json();
      if (res.ok) {
        setStatus("✅ Uploaded!");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        setStatus(`❌ Failed: ${data.error}`);
      }
    } catch (err) {
      console.error("Upload error:", err.message, err.stack);
      setStatus("❌ Upload failed. Check console.");
    }
  };

  return (
    <div>
      <AdminNavbar />
      <div className="container md:px-4 mx-auto pt-4">
        {/* Breadcrumb */}
        <div className="text-sm px-4 breadcrumbs">
          <ul>
            <li>
              <Link to="/">
                <BiSolidHome className="text-lg" />
                <span className="flex items-center">Home</span>
              </Link>
            </li>
            <li>
              <Link to="/dashboard">
                <span className="flex items-center">Dashboard</span>
              </Link>
            </li>
            <li>Upload Product Catalogue</li>
          </ul>
        </div>
        <div className="mx-auto bg-[#e7e7e7] mt-4 lg:p-8 p-4 my-8 rounded-2xl">
          <h1 className="text-2xl text-left font-light underline">
            Upload Product Catalogue (PDF)
          </h1>
          <form onSubmit={handleUpload} className="py-6">
            <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2 text-left">
              {/* Catalogue Name */}
              <div>
                <label className="block text-sm font-semibold leading-6 text-gray-900">
                  Catalogue Name
                </label>
                <input
                  type="text"
                  value={catalogueName}
                  onChange={(e) => setCatalogueName(e.target.value)}
                  placeholder="Enter catalogue name"
                  className="block w-full rounded-md border px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
                />
              </div>

              {/* Brand */}
              <div>
                <label className="block text-sm font-semibold leading-6 text-gray-900">
                  Brand Name
                </label>
                <select
                  value={brand}
                  onChange={(e) => setBrand(e.target.value)}
                  className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                >
                  <option disabled value="">
                    Select A Brand
                  </option>
                  <option value="Crown Farms">Crown Farms</option>
                  <option value="Rosemco">Rosemco</option>
                  <option value="Zoy">Zoy</option>
                  <option value="EFG Fashion">EFG Fashion</option>
                </select>
              </div>

              {/* Description */}
              <div className="sm:col-span-2">
                <label className="block text-sm font-semibold leading-6 text-gray-900">
                  Description
                </label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter description"
                  className="block w-full rounded-md border px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
                />
              </div>

              {/* Upload Image */}
              <div className="sm:col-span-2">
                <label className="block text-sm font-semibold leading-6 text-gray-900">
                  Upload Image
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="block w-full rounded-md border px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
                />
              </div>

              {/* Upload PDF */}
              <label className="form-control w-full sm:col-span-2">
                <div className="label">
                  <span className="label-text">Pick a file</span>
                  <span className="label-text-alt">Only PDF allowed</span>
                </div>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={handleFileChange}
                  className="file-input file-input-bordered w-full"
                />
                <div className="label">
                  <span className="label-text-alt">Required</span>
                  <span className="label-text-alt">Max size: 10MB</span>
                </div>
              </label>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="block w-full rounded-md px-3.5 py-2.5 text-center text-sm font-semibold text-white bg-[#55D4AB] hover:bg-[#f0ca4e] hover:text-black"
            >
              Upload PDF
            </button>
            {status && <p className="text-sm mt-2">{status}</p>}
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CatalogueUpload;
